import script from "./PdField.vue?vue&type=script&setup=true&lang=js"
export * from "./PdField.vue?vue&type=script&setup=true&lang=js"

import "./PdField.vue?vue&type=style&index=0&id=f01ad3f0&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f01ad3f0"]])

export default __exports__